import axios from 'axios';
export const EMOJIS = {
  raisedHand: '✋🏻',
};

export const checkDivsInMainPanel = () => {
  // Get the main panel div
  const mainPanel = document.querySelector('#main-panel');

  if (mainPanel) {
    // Check if the hls-screen-shares div is present
    const hlsScreenShareDiv = mainPanel.querySelector('#hls-screen-shares');
    const isHlsScreenSharePresent = !!hlsScreenShareDiv;

    // Get all divs with id starting with 'OT_' inside the main panel but not inside hls-screen-shares
    const otDivs = mainPanel.querySelectorAll(
      'div[id^="OT_"]:not(#hls-screen-shares div[id^="OT_"])'
    );
    const otDivCount = otDivs.length;

    // console.log(`Is hls-screen-shares present: ${isHlsScreenSharePresent}`);
    // console.log(`Number of OT divs: ${otDivCount}`);

    // Return the results as an object if needed
    return {
      isHlsScreenSharePresent,
      otDivCount,
    };
  } else {
    console.log('Main panel div not found.');
    return {
      isHlsScreenSharePresent: false,
      otDivCount: 0,
    };
  }
};

export const checkCanControl = async (id, finalUserData) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/v2/livemeeting/permissions/${id}`
    );
    if (response?.data?.success && response?.data?.permissions?.length > 0) {
      const permissions = response.data.permissions;
       const hostUser = permissions.find(
        (perm) => perm.role === 1
      );
      const cohostUser = permissions.find(
        (perm) => perm.role === 2
      );
      if (hostUser?.userid) {
        sessionStorage.setItem('hostUserId', hostUser.userid);
      }
      if (cohostUser?.userid) {
        sessionStorage.setItem('cohostUserId', cohostUser.userid);
      }
      const currentUserPermission = permissions.find(
        (perm) => perm.userid === finalUserData
      );
      if (currentUserPermission) {
        sessionStorage.setItem('hostPermission', currentUserPermission.role);
        return currentUserPermission.role;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching user permissions:', error);
    return null;
  }
};
export const canControlBroadcast = () => {
  const hostPermission = sessionStorage.getItem('hostPermission');
  return hostPermission == 1 || hostPermission == 2;
};

export const isPrimaryHost = () => {
  const hostPermission = sessionStorage.getItem('hostPermission');
  return hostPermission == 1;
};

export const isCoHost = () => {
  const hostPermission = sessionStorage.getItem('hostPermission');
  return hostPermission == 2;
};

export const hasActiveControl = () => {
  const activeController = sessionStorage.getItem('activeController');
  const userData = JSON.parse(sessionStorage.getItem('userData'));
  return activeController === userData?.userId;
};
export const addRoleLabelToVideo = (videoElementId, streamOrSubscriber,connectionUserMapRef) => {
  const videoElement = document.getElementById(videoElementId);
  if (!videoElement) return;
  
  // Don't add label if it already exists
  if (videoElement.querySelector('.role-label')) {
    return;
  }

  // Don't add labels to screenshare
  if (streamOrSubscriber.stream?.videoType === 'screen') {
    return;
  }

  // Don't add labels to screenshare container
  const screenshareContainer = document.getElementById('hls-screen-shares');
  if (screenshareContainer && screenshareContainer.contains(videoElement)) {
    return;
  }

  const existingLabel = videoElement.querySelector('.role-label');
  if (existingLabel) existingLabel.remove();

  let role = '0';
  let userId = null;

  try {
    if (window.publisher && videoElementId === window.publisher.id) {
      const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
      userId = userData.userId;
    } else if (streamOrSubscriber.stream?.connection?.data) {
      try {
        const connectionData = JSON.parse(streamOrSubscriber.stream.connection.data);
        userId = connectionData.userId;
      } catch (parseError) {
        console.warn('Failed to parse connection data:', parseError);
      }
    } else if (streamOrSubscriber.connection?.data) {
      try {
        const connectionData = JSON.parse(streamOrSubscriber.connection.data);
        userId = connectionData.userId;
      } catch (parseError) {
        console.warn('Failed to parse connection data:', parseError);
      }
    }

    if (!userId && connectionUserMapRef) {
        const connectionId = streamOrSubscriber.stream?.connection?.connectionId || 
                           streamOrSubscriber.connection?.connectionId;
        
        if (connectionId && connectionUserMapRef.current.has(connectionId)) {
          userId = connectionUserMapRef.current.get(connectionId);
          console.log('Got userId from connectionUserMap fallback:', userId);
        }
      }

    if (!userId) {
      console.warn('Could not determine userId for video element:', videoElementId);
      return;
    }

    // Get host and cohost IDs from sessionStorage
    const hostUserId = sessionStorage.getItem('hostUserId');
    const cohostUserId = sessionStorage.getItem('cohostUserId');

    // Determine role by comparing userId
    if (userId === hostUserId) {
      role = '1'; // Host
    } else if (userId === cohostUserId) {
      role = '2'; // Co-host
    } else {
      return; 
    }

  } catch (error) {
    console.error('Error getting role:', error);
    return;
  }

  let roleText = '';
  let bgColor = '';
  let borderColor = '';
  
  if (role == '1' || role == 1) {
    roleText = 'HOST';
    bgColor = 'rgba(209, 213, 219, 1)';
    borderColor = 'rgba(209, 213, 219, 1)';
  } else if (role == '2' || role == 2) {
    roleText = 'CO-HOST';
    bgColor = 'rgba(209, 213, 219, 1)';
    borderColor = 'rgba(209, 213, 219, 1)';
  } else {
    return; 
  }

  const label = document.createElement('div');
  label.className = 'role-label';
  label.textContent = roleText;
  label.style.cssText = `
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: ${bgColor};
    color: black;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 8px;
    font-weight: 600;
    z-index: 100;
    pointer-events: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: 1px solid ${borderColor};
  `;

  videoElement.style.position = 'relative';
  videoElement.appendChild(label);
};
export const restoreBroadcastUI = async (subscriberArrayRef,resetLeftPanelStyles,changeLayout,toast) => {
  console.log('Restoring broadcast UI state...');
  
  const broadcastId = sessionStorage.getItem('broadcastId');
  if (!broadcastId) {
    console.log('No active broadcast to restore');
    return;
  }
  
  try {
    // Fetch current broadcast state from server
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/status/${broadcastId}`,
      { method: 'POST' }
    );
    
    if (!response.ok) {
      console.error('Failed to fetch broadcast status');
      return;
    }
    
    const result = await response.json();
    const broadcastStreams = result?.streams || [];
    const broadcastStreamIds = broadcastStreams.map(stream => stream.streamId);
    
    console.log('Broadcast streams from server:', broadcastStreamIds);
    console.log('Current subscribers:', subscriberArrayRef.current.map(s => ({
      streamId: s.streamId,
      videoType: s.stream?.videoType
    })));
    
    // Get local streams data
    let streamsInLive = JSON.parse(sessionStorage.getItem('streamsInLive') || '[]');
    const storedStreams = JSON.parse(sessionStorage.getItem('streams') || '[]');
    
    console.log('Stored streams:', storedStreams);
    console.log('Streams in live (before):', streamsInLive);
    
    const mainPanel = document.getElementById('main-panel');
    if (!mainPanel) {
      console.error('Main panel not found');
      return;
    }
    
    // Clear main panel first
    const allDivsInMainPanel = Array.from(mainPanel.querySelectorAll('[id^="OT_"]'));
    allDivsInMainPanel.forEach(div => {
      console.log('Removing from main panel:', div.id);
      const originalContainer = div.getAttribute('data-original-container') || 'subscribers';
      const targetContainer = document.getElementById(originalContainer) || 
                             document.querySelector('.left-panel');
      if (targetContainer) {
        targetContainer.appendChild(div);
        div.classList.remove('highlight-border');
      }
    });
    
    // Also clear screenshare container from main panel
    const screenshareContainer = document.getElementById('hls-screen-shares');
    if (screenshareContainer && mainPanel.contains(screenshareContainer)) {
      const backstageButtonDiv = document.getElementById('backstage-button');
      if (backstageButtonDiv) {
        backstageButtonDiv.insertAdjacentElement('afterend', screenshareContainer);
      }
      screenshareContainer.classList.remove('highlight-border');
      screenshareContainer.style.height = '25%';
      screenshareContainer.style.width = '100%';
    }
    
    // Wait a moment for DOM to settle
    await new Promise(resolve => setTimeout(resolve, 500));
    
    //Find the screenshare OT div and move it inside the screenshare container
    const screenshareStream = subscriberArrayRef.current.find(
      sub => sub.stream && sub.stream.videoType === 'screen'
    );
    
    if (screenshareStream && screenshareContainer) {
      const screenshareOTDiv = document.getElementById(screenshareStream.id);
      
      if (screenshareOTDiv) {
        console.log('Found screenshare OT div:', screenshareOTDiv.id);
        
        // Check if OT div is NOT inside the screenshare container
        if (!screenshareContainer.contains(screenshareOTDiv)) {
          console.log('FIXING: Moving screenshare OT div into hls-screen-shares container');
          screenshareContainer.appendChild(screenshareOTDiv);
        } else {
          console.log('Screenshare OT div already inside container');
        }
        
        // Now check if screenshare should be in live
        if (broadcastStreamIds.includes(screenshareStream.streamId)) {
          console.log('Restoring screenshare to live stage');
          
          screenshareContainer.style.display = 'block';
          
          if (!mainPanel.contains(screenshareContainer)) {
            mainPanel.appendChild(screenshareContainer);
            screenshareContainer.classList.add('highlight-border');
            
            const mainPanelDivCheck = checkDivsInMainPanel();
            if (mainPanelDivCheck.otDivCount === 0) {
              screenshareContainer.style.height = '90%';
              screenshareContainer.style.width = '100%';
            }
          }
          
          sessionStorage.setItem('isScreenshareInLive', 'true');
          
          // Add to streamsInLive
          const existingIndex = streamsInLive.findIndex(s => s.streamId === screenshareStream.streamId);
          if (existingIndex === -1) {
            streamsInLive.push({ streamId: screenshareStream.streamId, inLive: true });
          } else {
            streamsInLive[existingIndex].inLive = true;
          }
        } else {
          console.log('Screenshare exists but not in broadcast');
          sessionStorage.setItem('isScreenshareInLive', 'false');
        }
      } else {
        console.warn('Screenshare OT div not found yet - might still be loading');
      }
    }
    
    //Move regular camera streams that should be in live stage
    let updatedStreamsInLive = [...streamsInLive];
    
    broadcastStreamIds.forEach(streamId => {
      const isScreenshare = subscriberArrayRef.current.find(
        sub => sub.streamId === streamId && sub.stream?.videoType === 'screen'
      );
      if (isScreenshare) {
        return;
      }
      
      // Find matching stream in stored streams
      const matchingStream = storedStreams.find(s => s.streamId === streamId);
      
      if (matchingStream) {
        const streamDiv = document.getElementById(matchingStream.id);
        
        if (streamDiv) {
          console.log('Moving stream to live stage:', matchingStream.id, streamId);
          
          // Determine original container
          let originalContainer = 'subscribers';
          if (window.publisher && streamDiv.id === window.publisher.id) {
            originalContainer = 'publishers';
          }
          
          streamDiv.setAttribute('data-original-container', originalContainer);
          
          // Move to main panel
          mainPanel.appendChild(streamDiv);
          streamDiv.classList.add('highlight-border');
          
          // Add to updated streams in live
          const existingIndex = updatedStreamsInLive.findIndex(s => s.streamId === streamId);
          if (existingIndex === -1) {
            updatedStreamsInLive.push({ streamId: streamId, inLive: true });
          } else {
            updatedStreamsInLive[existingIndex].inLive = true;
          }
        } else {
          console.warn('Stream div not found for:', matchingStream.id);
        }
      } else {
        console.warn('No matching stored stream for broadcast stream:', streamId);
      }
    });
    
    // Add any streams NOT in broadcast to streamsInLive with inLive: false
    storedStreams.forEach(stream => {
      if (!broadcastStreamIds.includes(stream.streamId)) {
        const existing = updatedStreamsInLive.find(s => s.streamId === stream.streamId);
        if (!existing) {
          updatedStreamsInLive.push({ streamId: stream.streamId, inLive: false });
        }
      }
    });
    
    // Update session storage with corrected state
    sessionStorage.setItem('streamsInLive', JSON.stringify(updatedStreamsInLive));
    
    console.log('Streams in live (after):', updatedStreamsInLive);
    
    // Apply layout
    resetLeftPanelStyles();
    const currentLayout = sessionStorage.getItem('layoutSelected') || 'bestFit';
    changeLayout(currentLayout);
    
    console.log('Broadcast UI state restored successfully');
    
    // toast.success('Broadcast state restored');
    
  } catch (error) {
    console.error('Error restoring broadcast UI:', error);
    toast.error('Failed to restore broadcast state');
  }
};
